import { lazy } from 'solid-js'
import { messages } from '../../pages/contact-page/contact-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/contact-page/contact-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/contact',
    titleMessage: messages.titleMessage,
}
